import React, { useState, useEffect } from 'react'
import {
	AppBar,
	Toolbar,
	IconButton,
	Menu,
	Typography,
	CircularProgress,
} from '@material-ui/core'
import { NavLink, Link } from 'react-router-dom'
import { Person as AccountIcon } from '@material-ui/icons'
import logo from '../../images/compkit-logo.png'
import { get } from 'lodash'
// styles
import useStyles from './styles'

import {
	useUserDispatch,
	signOut,
	useUserState,
} from '../../context/UserContext'
import { useLoadState } from '../../context/LoadingContext'
import { useCompanyState } from '../../context/CompanyContext'

export default function Header(props) {
	var classes = useStyles()

	// global

	var userDispatch = useUserDispatch()
	const { user } = useUserState()
	const { load } = useLoadState()
	const { first_name, last_name } = user
	const { company } = useCompanyState()
	const  { roles } = user
	// const [isLoading, setIsLoading] = useState()
	// local
	var [profileMenu, setProfileMenu] = useState(null)
	var [showOnlyReports, setShowOnlyReports] = useState(false)

	useEffect(() => {
		if(roles.includes('finance') || roles.includes('client_group')){
			setShowOnlyReports(true)
		}
	}, [roles])

	return (
		<AppBar position="fixed" className={classes.appBar}>
			<Toolbar className={classes.toolbar}>
				<Link to= "/app"
					weight="medium"
					className={classes.logotype}
				>
					<img src={logo} alt="Logo" className={classes.logo} />
				</Link>
				{showOnlyReports ? null :
				<NavLink
					activeClassName={classes.isActive}
					to="/app/employees"
					className={classes.link}
				>
					Employee Records
				</NavLink>}
				<NavLink
					activeClassName={classes.isActive}
					to="/app/reports"
					className={classes.link}
				>
					Reports
				</NavLink>
				{showOnlyReports ? null : <NavLink
					activeClassName={classes.isActive}
					to="/app/settings"
					className={classes.link}
				>
					Settings
				</NavLink>}
				<div className={classes.grow} />
				{load && <CircularProgress disableShrink size={20} />}
				<IconButton
					aria-haspopup="true"
					color="inherit"
					className={classes.headerMenuButton}
					aria-controls="profile-menu"
					onClick={e => setProfileMenu(e.currentTarget)}
				>
					<div className={classes.company}>
						{get(company, 'company_name', '')}
					</div>
					<AccountIcon classes={{ root: classes.headerIcon }} />
				</IconButton>
				<Menu
					id="profile-menu"
					open={Boolean(profileMenu)}
					anchorEl={profileMenu}
					onClose={() => setProfileMenu(null)}
					className={classes.headerMenu}
					classes={{ paper: classes.profileMenu }}
					disableAutoFocusItem
				>
					<div className={classes.profileMenuUser}>
						<Typography variant="h6" weight="medium">
							{first_name} {last_name}
						</Typography>
					</div>
					<div className={classes.profileMenuUser}>
						<Typography
							className={classes.profileMenuLink}
							color="primary"
							onClick={() => signOut(userDispatch, props.history)}
						>
							Sign Out
						</Typography>
					</div>
				</Menu>
			</Toolbar>
		</AppBar>
	)
}
